import React from 'react';
import { VideoIcon, PlayCircleIcon, ClipboardCheckIcon, UsersIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-259">
      <div className="max-w-4xl mx-auto px-6" data-id="element-260">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-261">
          ¿Cómo funciona?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-262">
          <div className="bg-white rounded-2xl p-8 shadow-sm" data-id="element-263">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-264">
              <VideoIcon className="w-7 h-7 text-[#0866FF]" data-id="element-265" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-266">
              Clases en vivo
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-267">(tipo Zoom o similar), donde:</p>
            <ul className="space-y-2 text-gray-600" data-id="element-268">
              <li data-id="element-269">• Te comparto pantalla y te muestro todo paso a paso.</li>
              <li data-id="element-270">• Puedes hacer preguntas en el momento.</li>
              <li data-id="element-271">• Vemos ejemplos de diferentes tipos de negocio.</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm" data-id="element-272">
            <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-6" data-id="element-273">
              <PlayCircleIcon className="w-7 h-7 text-purple-600" data-id="element-274" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-275">
              Acceso a las grabaciones
            </h3>
            <ul className="space-y-2 text-gray-600" data-id="element-276">
              <li data-id="element-277">
                • Si no puedes conectarte en vivo a alguna, la ves en diferido.
              </li>
              <li data-id="element-278">• Puedes repasar las partes que más te cuesten.</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm" data-id="element-279">
            <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-6" data-id="element-280">
              <ClipboardCheckIcon className="w-7 h-7 text-green-600" data-id="element-281" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-282">
              Ejercicios prácticos
            </h3>
            <ul className="space-y-2 text-gray-600" data-id="element-283">
              <li data-id="element-284">
                • Pequeñas tareas entre clases para que apliques en tu propia
                cuenta lo que vimos.
              </li>
              <li data-id="element-285">• Así no se queda en teoría.</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm" data-id="element-286">
            <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6" data-id="element-287">
              <UsersIcon className="w-7 h-7 text-orange-600" data-id="element-288" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-289">
              Espacio de soporte
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-290">(grupo/lista):</p>
            <ul className="space-y-2 text-gray-600" data-id="element-291">
              <li data-id="element-292">• Para hacer preguntas rápidas.</li>
              <li data-id="element-293">• Compartir pantalla si te trabas en algún paso concreto.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}